import React from 'react';
import './Animation.scss';

import Triangle from './Shapes/Triangle.js';
import Circle from './Shapes/Circle.js';

const TRIANGLE_DURATION = 10000;
const CIRC_DURATION = 4000;

export default class Animation extends React.Component {
  render() {
    return (
      <div className='animation'>
        <Triangle
          className="tri-1"
          initialTransform="rotate(60deg)"
          animeProps={{
            keyframes: [
              {
                rotate: '60deg'
              },
              {
                rotate: '90deg'
              },
              {
                rotate: '60deg',
                scale: 1
              },
            ],
            duration: TRIANGLE_DURATION
          }}
        />

        <Triangle
          className="tri-2"
          initialTransform="rotate(240deg)"
          animeProps={{
            keyframes: [
              {
                rotate: '240deg'
              },
              {
                rotate: '270deg'
              },
              {
                rotate: '240deg'
              },
            ],
            duration: TRIANGLE_DURATION,
          }}
        />

        <Triangle
          className="tri-3"
          initialTransform="rotate(120deg)"
          animeProps={{
            keyframes: [
              {
                rotate: '120deg',
                scale: 1
              },
              {
                rotate: '110deg',
                scale: 1.5
              },
              {
                rotate: '120deg',
                scale: 1
              },
            ],
            duration: TRIANGLE_DURATION,
          }}
        />

        <Circle
          className="circ-1"
          animeProps={{
            keyframes: [
              {
                translateY: 45
              },
              {
                translateY: 0
              },
              {
                translateY: -45
              },
              {
                translateY: 0
              },
            ],
            duration: CIRC_DURATION,
            easing: 'easeInOutSine'
          }}
        />
        <Circle
          className="circ-2"
          initialTransform="rotate(180deg)"
          animeProps={{
            keyframes: [
              {
                translateY: 35
              },
              {
                translateY: 0
              },
              {
                translateY: -35
              },
              {
                translateY: 0
              },
            ],
            duration: CIRC_DURATION,
            easing: 'easeInOutSine'
          }}
        />
        <Circle
          className="circ-3"
          initialTransform="rotate(-90deg)"
          animeProps={{
            keyframes: [
              {
                translateX: 25
              },
              {
                translateX: 0
              },
              {
                translateX: -25
              },
              {
                translateX: 0
              },
            ],
            duration: CIRC_DURATION,
            easing: 'easeInOutSine'
          }}
        />
        <Circle
          className="circ-4"
          animeProps={{
            keyframes: [
              {
                translateY: 65
              },
              {
                translateY: 0
              },
              {
                translateY: -65
              },
              {
                translateY: 0
              },
            ],
            duration: CIRC_DURATION,
            delay: 0,
            easing: 'easeInOutSine'
          }}
        />
        <Circle
          className="circ-5"
          animeProps={{
            keyframes: [
              {
                translateY: 85
              },
              {
                translateY: 0
              },
              {
                translateY: -85
              },
              {
                translateY: 0
              },
            ],
            duration: CIRC_DURATION,
            delay: CIRC_DURATION/2,
            easing: 'easeInOutSine'
          }}
        />
        <Circle
          className="circ-6"
          animeProps={{
            keyframes: [
              {
                translateY: 25
              },
              {
                translateY: 0
              },
              {
                translateY: -25
              },
              {
                translateY: 0
              },
            ],
            duration: CIRC_DURATION,
            delay: 0,
            easing: 'easeInOutSine'
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Animation/Animation.js